import React, { useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { debounce, startCase } from "lodash";
import obj from "../Utils/helpers";
import moment from "moment";

const ResultNew = () => {
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [filter, setFilter] = useState({
    fromPeriod: previousDate,
    toPeriod: currentDate,
    keyword: "",
    page: 1,
    limit: 100,
  });
  const handel = (e) => {
    setFilter((prev) => {
      return { ...prev, keyword: e };
    });
  };
  function handleChange(event) {
    debounceFn(event);
  }
  const debounceFn = useMemo(() => debounce(handel, 1000), []);

  const getTournamentData = async (type) => {
    const { status, data: response_users } = await apiGet(apiPath.resultList, {
      ...filter,
      gameType: type,
    });
    if (status === 200) {
      if (response_users.success) {
        setList(response_users?.results);
      }
    }
  };

  useEffect(() => {
    getTournamentData();
  }, []);
  useEffect(() => {
    getTournamentData();
  }, [filter?.toPeriod, filter?.keyword, filter?.page, filter?.fromPeriod]);
  return (
    <div>
      <div>
        <p className="reulst-h3">Check Result</p>
        <div className="resul-filter">
          <div className="result-time">
            <input
              type="date"
              onChange={(e) =>
                setFilter({
                  ...filter,
                  fromPeriod: e.target.value,
                })
              }
              max={new Date().toISOString().split("T")[0]}
              value={filter.fromPeriod}
            />
            <div>
              <span style={{ marginRight: "5px", fontSize: "10px" }}>to</span>
              <input
                type="date"
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    toPeriod: e.target.value,
                  })
                }
                min={
                  filter?.fromPeriod
                    ? new Date(filter?.fromPeriod).toISOString().split("T")[0]
                    : new Date()
                }
                disabled={filter.fromPeriod ? false : true}
                max={new Date().toISOString().split("T")[0]}
                value={filter.toPeriod}
              />
            </div>
          </div>
          <div style={{ padding: "7px", paddingTop: "4px" }}>
            <button
              onClick={() => getTournamentData("cricket")}
              className="btn-result"
            >
              Cricket
            </button>
            <button
              onClick={() => getTournamentData("soccer")}
              className="btn-result"
            >
              Soccer
            </button>
            <button
              onClick={() => getTournamentData("tennis")}
              className="btn-result"
            >
              Tennis
            </button>
            <button className="btn-result">Virtual T10</button>
          </div>
        </div>
        <div className="result-search">
          <input
            placeholder="Search..."
            onChange={(e) => handleChange(e.target.value)}
            type="text"
          />
        </div>
        <div
          style={{ marginBottom: "70px", width: "100%", overflowX: "scroll" }}
        >
          <table className="result-table">
            <thead>
              <tr>
                <th style={{ width: "7%", textAlign: "start" }}>Sr No.</th>{" "}
                <th>Sport</th>{" "}
                <th style={{ width: "18%", textAlign: "start" }}>Match Date</th>{" "}
                <th style={{ width: "55%", textAlign: "start" }}>Match Name</th>{" "}
                <th style={{ width: "15%", textAlign: "start" }}>Winner</th>{" "}
              </tr>
            </thead>
            <tbody>
              {list?.data?.map((res, index) => {
                return (
                  <tr>
                    <td style={{ textAlign: "center" }}>{index + 1}</td>
                    <td>{startCase(res?.gameType)}</td>{" "}
                    <td>{obj.dateFormat(res?.eventDateTime)}</td>
                    <td>{`${res?.eventName} - (${res?.eventId})`}</td>
                    <td>
                      {
                        res?.runners?.find((item) => {
                          return item?.SelectionId == res?.winner;
                        })?.RunnerName
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {list?.data?.length > 0 && (
            <div className="load-more">
              <button
                className="btn-result"
                style={{ width: "150px" }}
                onClick={() => {
                  if (list?.hasNextPage) {
                    setFilter((pre) => {
                      return { ...pre, page: list?.nextPage };
                    });
                  }
                }}
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultNew;
